import CarbonLink from '../../../navigation/Link';
import type { BlockComponentOverridesMap } from './BlockComponentOverridesContext';

/**
 * Override map that renders the Link block with Carbon's NextLink (client-side navigation).
 * Wrap the interface tree with `BlockComponentOverridesProvider` using this map in matrix
 * no-code, platform interface builder, and preview flows only. Do not use in delta matrix
 * so embedded interfaces keep default Link behaviour.
 */
export const DEFAULT_BLOCK_COMPONENT_OVERRIDES: BlockComponentOverridesMap = {
  Link: CarbonLink,
};
